import RestAPI from '../../../Common/restApi';
import axios from 'axios/index';

const transformArrayToHash = (response) => {
  response.data = response.data.reduce(function (map, obj) {
    map[obj.id] = obj;
    return map;
  }, {});

  return response;
};

export default class TasksApi {
  static show() {
    return TasksApi.getCustomAxios()({
      url: '/pro/tasks/show',
      method: 'GET',
    });
  }

  static getEmployees() {
    return RestAPI.get('/pro/account/employees_list_compact');
  }

  static update(taskId, params) {
    return RestAPI.updateWithFormData(`/pro/tasks/${taskId}`, params);
  }

  static getCustomAxios() {
    if (TasksApi.customAxios === undefined) {
      TasksApi.customAxios = axios.create();
      TasksApi.customAxios.interceptors.response.use(transformArrayToHash);
    }
    return TasksApi.customAxios;
  }

  static fetchTaskEvents(taskId) {
    return RestAPI.get(`/pro/tasks/${taskId}/events`);
  }

  static searchCustomer(query) {
    let requestUrl = `/pro/tasks/customer_search?q=${query}`;
    return RestAPI.get(requestUrl);
  }
}

TasksApi.customAxios = undefined;
